module.exports = __webpack_public_path__ + "img/img5.44016f1e.png";